import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import styled, { useTheme } from "styled-components";
import { getISOWeek } from "utilities/dateAndTime";

const parseCapacity = (projects) => {
    let weeks = [];
    let weekCodes = [];
    const maxCapacity = 35;
    let result = [];
    
    for(let i = 0; i < 12; i++)
    {
        let date = new Date();
        date.setDate(date.getDate() + (7 * i));
        const code = date.getFullYear() + "W" + getISOWeek(date);
        weeks.push("U"+getISOWeek(date));
        weekCodes.push(code);
    }

    weeks.forEach((week, i) => {
        let code = weekCodes[i]
        let cpt = maxCapacity;

        projects.forEach(prj => {
            if(prj.projectActivity.activity[code]) cpt -= Math.round(prj.projectActivity.activity[code]);
        });

        result.push({
            week,
            capacity: cpt
        })
    });

    return result;
}

export const ProjectsActivityCapacity = ({projects}) => {
    
    const capacity = parseCapacity(projects);

    const GlobalTheme = useTheme();

    return (
        <StyledProjectsActivityCapacity>
            <BarChart
                style={{height: '100%', width: '100%'}}
                responsive
                data={capacity}
            >
                <CartesianGrid
                    vertical={false}
                    strokeDasharray={[5, 5]}
                />
                <XAxis
                    dataKey='week'
                    fontSize={GlobalTheme.fontSize.sm}
                    fontWeight={600}
                />
                <YAxis
                    dataKey='capacity'
                    fontSize={GlobalTheme.fontSize.sm}
                    fontWeight={600}
                    tickFormatter={(v) => {return Math.round(v) + "t."}}
                />
                <Bar
                    dataKey='capacity'
                    shape={(props) => <CustomBar {...props}/>}
                />
            </BarChart>
        </StyledProjectsActivityCapacity>
    )
}

const StyledProjectsActivityCapacity = styled.div`
    height: 100%;
    min-height: 300px;
`

const CustomBar = (props) => {
    const GlobalTheme = useTheme();
    const { x, y, width, height, value } = props;

    const fillColor = value >= 0 ? GlobalTheme.colors.accentForeground : GlobalTheme.colors.errorForeground;

    const normalizedHeight = Math.abs(height);
    const normalizedY = height < 0 ? y + height : y;

    return (
        <g>
            <rect
                x={x}
                y={normalizedY}
                width={width}
                height={normalizedHeight}
                fill={fillColor}
                strokeWidth={1}
                rx={6}
                ry={6}
            />
            <text
                x={x + width / 2}
                y={value >= 0 ? y + normalizedHeight + 14 : y - normalizedHeight - 8}
                textAnchor="middle"
                fontSize={12}
                fontWeight={600}
                fill={fillColor}
            >
                {Math.round(value) + "t."}
            </text>
        </g>
        
    )

}
